import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const createPickSessionFilter = {
  name: "createPickSessionFilter" as const,
  input: z.object({
    name: z.string(),
    filters: z.array(AdvancedFilterDataSchema),
  }),
  output: z.object({ success: z.boolean() }),
};
